var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-8 text-center" }, [
        _vm.privacyInfoEnabled
          ? _c("span", [
              _c(
                "a",
                {
                  attrs: {
                    href: "#",
                    "aria-expanded": "false",
                    "aria-controls": "privacyInfo"
                  },
                  on: { click: _vm.showPrivacyInfo }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.T.adatvedelem[_vm.lang]) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" - \n      ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "#",
              "aria-expanded": "false",
              "aria-controls": "bruttoNettoInfo"
            },
            on: { click: _vm.showBruttoNettoInfo }
          },
          [_vm._v(_vm._s(_vm.T.bruttoNettoInfo[_vm.lang]))]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-2" }, [
      _c("div", { staticClass: "col" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-8 text-center" }, [
        _c(
          "div",
          {
            staticClass: "alert alert-info",
            class: {
              "collapse.show": _vm.privacyInfoShow,
              collapse: !_vm.privacyInfoShow
            },
            attrs: { id: "privacyInfo", role: "alert" }
          },
          [_vm._v(_vm._s(_vm.T.privacyInfo[_vm.lang]))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "alert alert-info",
            class: {
              "collapse.show": _vm.bruttoNettoInfoShow,
              collapse: !_vm.bruttoNettoInfoShow
            },
            attrs: { id: "bruttonettoinfo", role: "alert" }
          },
          [
            _c("p", { staticClass: "text-justify" }, [
              _c("strong", [_vm._v(_vm._s(_vm.T.nettoBer[_vm.lang]) + ":")]),
              _vm._v(
                "\n          " +
                  _vm._s(_vm.T.nettoBerInfo[_vm.lang]) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "text-justify" }, [
              _c("strong", [
                _vm._v(_vm._s(_vm.T.haviBruttoBer[_vm.lang]) + ":")
              ]),
              _vm._v(
                "\n          " +
                  _vm._s(_vm.T.bruttoBerInfo[_vm.lang]) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "text-justify" }, [
              _c("strong", [
                _vm._v(_vm._s(_vm.T.munkaltatoiAdok[_vm.lang]) + ":")
              ]),
              _vm._v(
                "\n          " +
                  _vm._s(_vm.T.munkaltatoiAdokInfo[_vm.lang]) +
                  "\n        "
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6f70a83e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f70a83e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/Info.vue
// module id = 37
// module chunks = 0